import { getEnvConfig } from 'src/helpers/config';

export const sendClarityEvent = (key: string, value: string) => {
  const { clarity } = getEnvConfig();

  if (!clarity) {
    return;
  }

  window.clarity?.('set', key, value);
};
